import {interopDefault} from '@/utils/helpers'

const VisaSearchPage = () => interopDefault(import('~/pages/visa/VisaSearchPage'))
const VisaBookingPage = () => interopDefault(import('~/pages/visa/VisaBookingPage'))
const VisaConfirmationPage = () => interopDefault(import('~/pages/visa/VisaConfirmationPage'))

export default [
    {
        path: '/search/visa',
        component: VisaSearchPage,
        name: 'visaSearch',
        meta: {
            unwrapped: true,
        },
    },
    {
        path: '/visa/booking',
        component: VisaBookingPage,
        name: 'visaBooking',
        meta: {
            validate: route => !!route.query.offerKey,
        },
    },
    {
        path: '/visa/confirmation',
        component: VisaConfirmationPage,
        name: 'visaConfirmation',
        meta: {
            unwrapped: true,
        },
    },
]
